import { gql, TypedDocumentNode } from "@apollo/client";

import {
  AwsIntegrationIntentProjectAttachment,
  MutationAwsIntegrationIntentProjectAttachArgs,
} from "types/generated";

import { AWS_INTEGRATION_ATTACHMENT_FRAGMENT } from "../gql";

export const ATTACH_AWS_INTEGRATION_TO_INTENT_PROJECT: TypedDocumentNode<
  { awsIntegrationIntentProjectAttach: AwsIntegrationIntentProjectAttachment },
  MutationAwsIntegrationIntentProjectAttachArgs
> = gql`
  mutation AttachAwsIntegrationToIntentProject(
    $intentProject: ID!
    $integration: ID!
    $read: Boolean!
    $write: Boolean!
    $awsRegion: String!
  ) {
    awsIntegrationIntentProjectAttach(
      intentProject: $intentProject
      integration: $integration
      read: $read
      write: $write
      awsRegion: $awsRegion
    ) {
      ...AwsIntegrationAttachment
    }
  }
  ${AWS_INTEGRATION_ATTACHMENT_FRAGMENT}
`;
